<div
  class="flex flex-col h-screen bg-gray-50 border border-cinza transition-all duration-300"
  [ngClass]="{ 'w-64': !isCollapsed, 'w-20': isCollapsed }"
  (mouseenter)="openSidebar()"
  (mouseleave)="closeSidebar()"
>
  @if (isCollapsed) {
  <div class="flex items-center justify-center p-4">
    <img ngSrc="/mini-logo.svg" height="30" width="30" alt="Logo" />
  </div>
  }@else {
  <div class="flex items-center justify-between p-4">
    <img ngSrc="/logo.svg" height="38" width="125" alt="Logo" priority />

    <img
      ngSrc="/icons/pin.svg"
      width="20"
      height="20"
      alt="pin"
      class="cursor-pointer"
      (click)="toggleFixed()"
      [ngClass]="{
        'origin-center rotate-45 opacity-50': !fixed
      }"
    />
  </div>
  }

  <nav class="flex-1 space-y-2 px-2">
    <ng-container>
      @for (item of menuItems; track $index) { @if(!item.children){
      <div class="relative group">
        <a
          [routerLink]="item.path"
          routerLinkActive="active"
          class="flex items-center gap-3 px-3 py-3 rounded-full transition-all hover:bg-foreground"
          [ngClass]="{
            'justify-center': isCollapsed,
            'pl-3': !isCollapsed
          }"
          *kaHasRoles="item.role; resource: 'tefbox-api-lojista'"
        >
          <img
            [src]="'/icons/' + item.icon + '.svg'"
            [ngClass]="isCollapsed ? 'h-6 w-6' : 'h-5 w-5'"
          />

          @if (!isCollapsed) {
          <span class="text-sm font-medium">
            {{ item.label }}
          </span>
          } @if (item.notification && !isCollapsed) {
          <span class="ml-auto h-2 w-2 rounded-full bg-red-600"></span>
          }
        </a>

        @if (item.notification && isCollapsed) {
        <span class="absolute top-1.5 right-2 h-2 w-2 rounded-full bg-red-600"> </span>
        }
      </div>
      }@else {
      <div
        class="relative group"
        *kaHasRoles="item.role; resource: 'tefbox-api-lojista'"
        class="cursor-pointer"
      >
        <app-accordion [menu]="item" [isCollapsed]="isCollapsed"></app-accordion>
      </div>
      } }
    </ng-container>
  </nav>
</div>
